import Parse from 'parse';
export default Parse.Object.extend('MaintenanceEvent');